import { defineMessages } from 'react-intl';

export default defineMessages({
  actionsMenu: {
    id: 'frontbucket.repository.source.header.actionsMenu',
    description: 'Label for the repository actions menu',
    defaultMessage: 'Repository actions',
  },
  heading: {
    id: 'frontbucket.repository.source.breadcrumbs.pageBreadcrumb',
    description: 'Default heading for the source section',
    defaultMessage: 'Source',
  },
  newFileAction: {
    id: 'frontbucket.repository.source.header.newFileAction',
    description: 'Menu action to create a new file in a directory',
    defaultMessage: 'Add file',
  },
  inviteAction: {
    id: 'frontbucket.repository.source.header.inviteAction',
    description: 'Button action to share a repository',
    defaultMessage: 'Invite',
  },
  shareAction: {
    id: 'frontbucket.repository.source.header.shareAction',
    description: 'Menu action to share a repository',
    defaultMessage: 'Share repository',
  },
  manageNotifications: {
    id: 'frontbucket.repository.source.manageNotifications',
    description: 'Menu action to manage repository notifications',
    defaultMessage: 'Manage notifications',
  },
  leaveRepoAction: {
    id: 'frontbucket.repository.source.header.leaveRepoAction',
    description: 'Menu action to leave a repository',
    defaultMessage: 'Leave repository',
  },
  downloadRepoAction: {
    id: 'frontbucket.repository.source.header.downloadRepoAction',
    description: 'Menu action to download a repository',
    defaultMessage: 'Download repository',
  },
  compareRepoAction: {
    id: 'frontbucket.repository.source.header.compareRepoAction',
    description: 'Menu action to compare branches or tags',
    defaultMessage: 'Compare commits, branches or tags',
  },
  forkRepoAction: {
    id: 'frontbucket.repository.source.header.forkRepoAction',
    description: 'Menu action to fork a repo',
    defaultMessage: 'Fork this repository',
  },
});
